



































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'

@Component<Label>({})
export default class Label extends Vue {
    @Prop({ type: Boolean, required: true, default: false })
    public readonly finished!: boolean

    @Prop({ type: String, required: true })
    public readonly label!: string

    @Prop({ type: Number, required: true })
    public readonly position!: number

    @Prop({ type: String, required: true })
    public readonly title!: string

    @Prop({ type: Boolean, required: false, default: false })
    public readonly clickable!: boolean

    @Prop({ type: Boolean, required: false, default: true })
    public readonly showBadge!: boolean

    @Getter public readonly currentStep
    @Getter public readonly isEditing
    @Getter public readonly isComplete
    @Getter public readonly allSteps
    @Action public setCurrentStep

    public get showCheckmark() {
        return (
            this.isEditing &&
            this.finished &&
            !this.isCurrentStep &&
            this.isComplete
        )
    }

    public get shouldDisplayAsFinished() {
        return this.isCurrentStep || this.finished
    }

    public get isCurrentStep() {
        return (
            this.currentStep !== undefined &&
            this.currentStep.position === this.position
        )
    }

    public clickLabel() {
        if (!this.clickable) {
            return
        }
        this.setCurrentStep(this.allSteps[this.position-1])
    }
}
